import { useCallback, useContext, useMemo } from 'react';
import EntityDefinitionsContext from '../contexts/EntityDefinitionsContext';

export const useGetEntity = () => {
  const { entityDefinitions } = useContext(EntityDefinitionsContext);

  const getEntity = useCallback(
    (entityId: string): EntityDetails.Entity | undefined => {
      return entityDefinitions.find(
        (entityDefinition) => entityDefinition.id === entityId,
      );
    },
    [entityDefinitions],
  );

  return getEntity;
};

const useGetEntityApp = () => {
  const { entityDetailsApps } = useContext(EntityDefinitionsContext);

  const getEntityApp = useCallback(
    ({
      entityId,
      entityAppId,
    }: {
      entityId: string;
      entityAppId?: string;
    }): EntityDetails.App | undefined => {
      if (entityAppId) {
        return entityDetailsApps.find(
          (entityApp) => entityApp.id === entityAppId,
        );
      }

      return entityDetailsApps.find((a) => a.entityId === entityId);
    },
    [entityDetailsApps],
  );

  return getEntityApp;
};

const useEntity = ({
  entityId,
  entityAppId,
}: {
  entityId?: string;
  entityAppId?: string;
}) => {
  const getEntity = useGetEntity();
  const getEntityApp = useGetEntityApp();

  const entity = useMemo(() => {
    if (!entityId) {
      return;
    }

    return getEntity(entityId);
  }, [entityId, getEntity]);

  const app = useMemo(() => {
    if (!entityId) {
      return;
    }

    return getEntityApp({
      entityAppId,
      entityId,
    });
  }, [entityAppId, entityId, getEntityApp]);

  return { entity, app };
};

export default useEntity;
